import { useToast } from '../../state-management/contexts/ToastContext'

interface ToastBaseProps {
  width?: string
  className?: string
  style?: React.CSSProperties
}

export const ToastBase = ({ width, className = '', style = {} }: ToastBaseProps) => {
  const { message, isVisible, currentToastZIndex, actionLabel, dismissToast } = useToast()

  const combinedStyle = {
    ...style,
    zIndex: currentToastZIndex || style.zIndex
  }

  const hasAction = !!actionLabel

  return (
    <div className={`${className} pointer-events-none`} style={combinedStyle}>
      <div
        className={`${hasAction ? 'bg-[#095EB2]' : 'bg-[#004D99] max-w-sm'} text-white px-4 py-[10px] rounded-[14px] ${isVisible && message
          ? 'translate-y-0 opacity-100 transition-all duration-300 ease-out transform pointer-events-auto'
          : 'translate-y-8 opacity-0 pointer-events-none'
          }`}
        style={{ width }}
      >
        <div className={`flex items-center ${hasAction ? 'gap-3' : ''}`}>
          <div className='flex-1 min-w-0'>
            <p className={`text-sm font-medium ${hasAction ? 'text-left' : 'text-center'}`}>{message || ''}</p>
          </div>
          {hasAction ? (
            <div
              className='cursor-pointer shrink-0 text-sm font-medium whitespace-nowrap text-[#BFDFFF]'
              onClick={dismissToast}
            >
              {actionLabel}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
